<template>
  <div>

    <post :posts="posts" />
    <b-row>
      <b-col>
        <apply-doc-statistics
          v-if="applyDocStatistics.length && false"
          :apply-doc-count="applyDocStatistics[0]"
        />
      </b-col>
    </b-row>
    <h1 class="text-center mb-2">
      {{ $t('Statistics') }}
    </h1>
    <b-row class="align-self-stretch mb-1">
      <b-col
        md="4"
        class="mb-1"
      >
        <count-users
          v-if="userCount.length"
          :user-count="userCount[0]"
          :filter="['male_user', 'female_user']"
        />
      </b-col>
      <b-col
        md="8"
        class="mb-1"
      >
        <applied-year-count
          v-if="appliedYearCount.length"
          :list="appliedYearCount"
        />
      </b-col>
    </b-row>

    <b-row class="align-self-stretch mb-1">
      <b-col
        md="4"
        class="mb-1"
      >
        <count-users
          v-if="userCount.length"
          :user-count="userCount[0]"
          :filter="['phd_user', 'dc_user']"
          :color-start="6"
          title="By degree"
        />
      </b-col>
      <b-col
        md="4"
        class="mb-1"
      >
        <count-users
          v-if="userCount.length"
          :user-count="userCount[0]"
          :filter="['senior_research_fellow_user', 'accociate_professor_user', 'professor_user', 'academic_user']"
          :color-start="3"
          title="By academic title"
        />
      </b-col>
      <b-col
        md="4"
        class="mb-1"
      >
        <count-users
          v-if="userCount.length"
          :user-count="userCount[0]"
          :filter="['foreign_user', 'local_user']"
          :color-start="2"
          title="Users by region"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCol, BRow,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Post from './component/Post.vue'
import store from '@/store'
import postModule from '@/store/post'
import statisticModule from '@/store/statistic'
import AppliedYearCount from '@/views/pages/dashboard/chart/AppliedYearCount.vue'
import CountUsers from '@/views/pages/dashboard/chart/CountUsers.vue'
import ApplyDocStatistics from '@/views/pages/dashboard/chart/ApplyDocStatistics.vue'

export default {
  name: 'MainPage',
  components: {
    Post,
    AppliedYearCount,
    BCol,
    BRow,
    CountUsers,
    ApplyDocStatistics,
  },
  computed: {
    posts() {
      return this.$store.state[this.MODULE_POST].posts
    },
    appliedYearCount() {
      return this.$store.state[this.MODULE_STATISTIC].appliedYearCount
    },
    userCount() {
      return this.$store.state[this.MODULE_STATISTIC].userCount
    },
    applyDocStatistics() {
      return this.$store.state[this.MODULE_STATISTIC].applyDocStatistics
    },
  },
  created() {
    Promise.all([
      this.$store.dispatch(`${this.MODULE_POST}/list`, {
        ordering: '-id',
        limit: 8,
        status: this.postStatusActive,
      }),
      this.$store.dispatch(`${this.MODULE_STATISTIC}/appliedYearCount`),
      this.$store.dispatch(`${this.MODULE_STATISTIC}/userCount`),
      this.$store.dispatch(`${this.MODULE_STATISTIC}/applyDocStatistics`),
    ]).catch(error => {
      this.$errorSwal(this, error)
    })
  },
  setup() {
    const { postStatusActive } = store.state.staticModule
    const MODULE_POST = 'post-front'
    const MODULE_STATISTIC = 'statistic-front'
    // Register module
    if (!store.hasModule(MODULE_POST)) store.registerModule(MODULE_POST, postModule)
    if (!store.hasModule(MODULE_STATISTIC)) store.registerModule(MODULE_STATISTIC, statisticModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_POST)) store.unregisterModule(MODULE_POST)
      if (store.hasModule(MODULE_STATISTIC)) store.unregisterModule(MODULE_STATISTIC)
    })

    return {
      MODULE_POST,
      MODULE_STATISTIC,
      postStatusActive,
    }
  },
}
</script>

<style scoped>
  .icon-color {
    fill: #625f6e;
  }
</style>
